import { UserRole } from '@authentication/shared-enums';
import { IsNotEmpty } from 'class-validator-i18n';

import { BaseSignInByEmailRequestDTO } from './BaseSignInByEmailRequestDTO';

export class SignInByEmailRequestDTO extends BaseSignInByEmailRequestDTO {
  @IsNotEmpty()
  role: UserRole;
}
